import React, { InputHTMLAttributes, ReactElement, useState } from "react";
import { EmptyMessaging, Logo, Logout2, MenuIcon, Notification, User, UsersGroup } from "../../assets";
import ButtonIcon from "../components/button_icon";
import Menu from '@mui/material/Menu';
import Fade from '@mui/material/Fade';
import { Button, ProfileCard } from "../components";
import HeaderItem from "./header_item";
import { AppBar, Drawer } from "@mui/material";
import HeaderResponsive from "./header_responsive";
import CurrentDate from "./current_date";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { logout } from "../../core/service";
import routes from "../../core/routes";


interface Props extends InputHTMLAttributes<HTMLInputElement> {
  title: string
  userData?: any;
}

export function Header({ title, userData }: Props): ReactElement {

  const [openMenu, setOpen] = useState(false);
  const [anchorElNotifications, setAnchorElNotifications] = React.useState<null | HTMLElement>(null);
  const openNotifications = Boolean(anchorElNotifications);
  const handleClickNotification = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNotifications(event.currentTarget);
  };
  const handleCloseNotifications = () => {
    setAnchorElNotifications(null);
  };
  // 
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <div className="hide-desktop">
        <Drawer anchor={"left"} open={openMenu} onClose={() => setOpen(false)}>
          <div className="header-drawer" onClick={() => setOpen(false)}>

            <HeaderResponsive />
          </div>
        </Drawer>
      </div>

      <AppBar style={{ background: '#ffffff', paddingBottom: "10px", borderRadius: "10px 10px 0  0", boxShadow: "0px 1px 10px 0px rgba(0,0,0,0.12)", height: "84px" }} position="sticky">
        <div className="header mt-2">

          <h2 className="title hide-mobile">
            {title}
          </h2>
          <Link to="/">
            <img src={Logo} alt="هامرز" className="header-logo hide-desktop" />
          </Link>

          <div className="content hide-mobile">

            <CurrentDate myStyle="" />

            <div className="">
              <div
                id="fade-button"
                aria-controls={open ? 'fade-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
              >
                <ButtonIcon image={User} />
              </div>
              <Menu
                className="notification-list"
                anchorEl={anchorEl}
                id="account-menu"
                open={open}
                onClose={handleClose}
                onClick={handleClose}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: 'visible',
                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                    mt: 1.5,
                    '& .MuiAvatar-root': {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    '&:before': {
                      content: '""',
                      display: 'block',
                      position: 'absolute',
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: 'background.paper',
                      transform: 'translateY(-50%) rotate(45deg)',
                      zIndex: 0,
                    },
                  },
                }}
                transformOrigin={{ horizontal: 'left', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
              >
                <ProfileCard name={`${userData?.first_name} ${userData?.last_name}`} isMini image={userData?.picture} details={userData?.brag_type} />
                <hr className="line" />
                <HeaderItem
                  myStyle="custom-style"
                  name="پروفایل کاربری"
                  link="/"
                  userProfile
                  icon={<UsersGroup />}
                />
                <div onClick={() => logout()}>

                  <HeaderItem
                    myStyle="custom-style"
                    name="خروج از حساب کاربری"
                    link="/"
                    userProfile
                    icon={<Logout2 />}
                    onClick={() => logout()}
                  />
                </div>

              </Menu>
            </div>
            <div className="d-flex align-items-center ">
             
              <Menu
                id="notification-list"
                className="notification-list"
                MenuListProps={{
                  'aria-labelledby': 'fade-button',
                }}
                anchorEl={anchorElNotifications}
                open={openNotifications}
                onClose={handleCloseNotifications}
                TransitionComponent={Fade}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: 'visible',
                    filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                    mt: 1.5,
                    '& .MuiAvatar-root': {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1,
                    },
                    '&:before': {
                      content: '""',
                      display: 'block',
                      position: 'absolute',
                      top: 0,
                      right: 14,
                      width: 10,
                      height: 10,
                      bgcolor: 'background.paper',
                      transform: 'translateY(-50%) rotate(45deg)',
                      zIndex: 0,
                    },
                  },
                }}

                transformOrigin={{ horizontal: 'left', vertical: 'top' }}
                anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
              >
                {/* <span className="notification-list-title">
                  <img src={CheckRead} alt="هامرز" />
                  نشان به مطالعه شده
                </span> */}
                <div className="notification-list-img">
                  <img src={EmptyMessaging} alt="هامرز" className="img" />

                  <span className="title">
                    پیام {" "}
                    <span className="bold-title">
                      خوانده نشده

                    </span> جدید ندارید
                  </span>
                </div>
                {/* <AnnouncementsCard2 onClick={handleCloseNotifications} title="آخرین مهلت تعیین وضعیت نمایندگان" date="1402/08/24" time="16:49 " Unread={true} />
      <AnnouncementsCard2 title="آخرین مهلت تعیین وضعیت نمایندگان" date="1402/08/24" time="16:49" /> */}
                {/* <Button myStyle="bg-blue w-100" title="مشاهده همه اطلاعیه ها" onClick={() => window.location.href = `${process.env.REACT_APP_CRM_URL}/`} /> */}
                <Button myStyle="bg-blue w-100" title="مشاهده همه اطلاعیه ها" onClick={() => {}} />

              </Menu>
              <div className="hide-desktop custome-width">
                <div className="menu has-cursor " onClick={() => setOpen(true)}>
                  <img src={MenuIcon} alt="هامرز" />
                </div>

              </div>
            </div>
          </div>


        </div>
      </AppBar>
    </>
  )
}

const mapStateToProps = (dispatch: any) => {
  return {
    dispatch,
    userData: dispatch.general.userData,
  };
};
export default connect(mapStateToProps)(Header);
